/* Vintage Duft theme script.
   Settings come from layout/theme.liquid as window.VD. Product data comes from
   /collections/<handle>?view=shelf-data (templates/collection.shelf-data.liquid). */
(() => {
"use strict";
const VD = Object.assign({
  mode: "enquiry", email: "", whatsapp: "", shopName: "Vintage Duft", root: "/", shelf: "/collections/all",
  cart: "/cart", cartAdd: "/cart/add", cartChange: "/cart/change", moneyFormat: "€{{amount_with_comma_separator}}",
  showPrices: true, showSoldOut: false, prestige: [], dataUrl: "/collections/all?view=shelf-data"
}, window.VD || {});
const CHECKOUT = VD.mode === "checkout";
const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];
const esc = s => String(s ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const norm = s => String(s).normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
const store = {
  get(k, d) { try { const v = localStorage.getItem("vd:" + k); return v ? JSON.parse(v) : d; } catch { return d; } },
  set(k, v) { try { localStorage.setItem("vd:" + k, JSON.stringify(v)); } catch {} }
};
const T = CHECKOUT
  ? { add: "Add to bag", addLong: " to bag", inBag: "In your bag", inShort: "In bag", bag: "Your bag", empty: "Your bag is empty", added: "Added to bag", view: "View bag", list: "bag" }
  : { add: "Add to enquiry", addLong: " to enquiry", inBag: "In your enquiry", inShort: "In enquiry", bag: "Your enquiry", empty: "Your enquiry is empty", added: "Added to enquiry", view: "View enquiry", list: "enquiry" };
const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
const smooth = () => reduced ? "auto" : "smooth";

/* ---------- money ---------- */
function money(cents) {
  const n = cents / 100;
  const fmt = (d, ts, ds) => { const [i, f] = n.toFixed(d).split("."); return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (f ? ds + f : ""); };
  return String(VD.moneyFormat).replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
    k === "amount_no_decimals" ? fmt(0, ",", ".") :
    k === "amount_with_comma_separator" ? fmt(2, ".", ",") :
    k === "amount_no_decimals_with_comma_separator" ? fmt(0, ".", ",") :
    k === "amount_with_apostrophe_separator" ? fmt(2, "'", ".") :
    k === "amount_with_space_separator" ? fmt(2, " ", ",") : fmt(2, ",", "."));
}
const plainText = html => { const d = document.createElement("textarea"); d.innerHTML = html; return d.value; };

/* ---------- data ---------- */
const join = (a, b) => a.replace(/\/$/, "") + "/" + b.replace(/^\//, "");
const productUrl = h => join(VD.root, "products/" + h);
const shelfUrl = (params = {}) => {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) [].concat(v).forEach(x => x != null && x !== "" && q.append(k, x));
  const s = q.toString(); return VD.shelf + (s ? "?" + s : "");
};
const houseHref = b => shelfUrl({ brand: b });
const cap = s => s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : s;
const BODY = new Set(["Body & grooming", "Bathline", "After shave"]);
const isBody = p => BODY.has(p.c);
function prep(r) {
  const p = { id: r.h, h: r.h, b: r.b || "", t: r.t || "", c: r.c || "Eau de Parfum", v: r.v, pr: +r.pr || 0, q: Math.max(0, r.q | 0), a: r.a !== false,
    e: r.e || "", img: r.img || "", u: r.u || productUrl(r.h), g: "Unisex", k: "Perfume", ml: null, n: [] };
  for (const tag of r.tg || []) {
    const i = tag.indexOf(":"); if (i < 0) continue;
    const k = tag.slice(0, i).trim().toLowerCase(), v = tag.slice(i + 1).trim();
    if (k === "for") p.g = cap(v);
    else if (k === "pack") p.k = /promo|tester/i.test(v) ? "Promotional" : "Perfume";
    else if (k === "ml") p.ml = parseFloat(v.replace(",", ".")) || null;
    else if (k === "note") p.n.push(v);
  }
  if (!p.a) p.q = 0;
  const ml = p.ml;
  p.sz = ml == null ? "NA" : ml <= 30 ? "S" : ml <= 75 ? "M" : ml <= 100 ? "L" : "XL";
  p.price = VD.showPrices && p.pr > 0 ? p.pr : null;
  p.s = norm([p.b, p.t, p.c, p.e, p.k === "Promotional" ? "promotional promo tester" : "boxed", p.g].join(" "));
  return p;
}
async function fetchShelf(url) {
  const key = "vd:shelf:" + url;
  try { const c = JSON.parse(sessionStorage.getItem(key)); if (c && Date.now() - c.t < 300000) return c.d; } catch {}
  const get = async n => {
    const r = await fetch(url + (url.includes("?") ? "&" : "?") + "page=" + n, { credentials: "same-origin" });
    if (!r.ok) throw new Error("shelf " + r.status);
    return JSON.parse(await r.text());
  };
  const first = await get(1); let list = first.products || [];
  if (first.pages > 1) (await Promise.all(Array.from({ length: first.pages - 1 }, (_, i) => get(i + 2)))).forEach(x => { list = list.concat(x.products || []); });
  try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: list })); } catch {}
  return list;
}
let ALL = [], P = [], byId = new Map(), HOUSES = [];
const visible = p => VD.showSoldOut || p.a;
function setData(raw) {
  ALL = raw.map(prep);
  byId = new Map(ALL.map(p => [p.id, p]));
  P = ALL.filter(visible);
  HOUSES = [...new Set(P.map(p => p.b).filter(Boolean))].sort((a, b) => norm(a).localeCompare(norm(b)));
}
const mlText = ml => ml == null ? "" : String(ml) + " ml";
const packText = p => p.k === "Promotional" ? "Promotional" : "Boxed";
const canBuy = p => p.q > 0 && (!CHECKOUT || p.pr > 0);

/* ---------- bottle drawings ---------- */
const TINTS = ["#D9A441", "#E3A6B4", "#E6CF7A", "#9EC6CC", "#C8B6DA", "#E2D3BE", "#C25A72", "#A9C79A", "#F0B98A"];
const hash = s => { let h = 2166136261; for (const ch of String(s)) { h ^= ch.charCodeAt(0); h = Math.imul(h, 16777619); } return h >>> 0; };
let uid = 0;
function capSVG(type, ny) {
  const t = `transform="translate(0 ${ny - 76})"`;
  if (type === 0) return `<g ${t}><rect class="g-garnet-ink" x="85" y="62" width="30" height="9" rx="2"/><path class="g-garnet" d="M80 62h40l7-9V41l-7-9H80l-7 9v12z"/><path d="M80 32l6 9h28l6-9M73 41h54M86 41v21M114 41v21M73 53h54" fill="none" stroke="#fff" stroke-opacity=".45" stroke-width="1.2"/></g>`;
  if (type === 1) return `<g ${t}><rect class="g-ink" x="78" y="30" width="44" height="42" rx="3"/><rect x="84" y="34" width="5" height="34" fill="#fff" opacity=".18"/></g>`;
  return `<g ${t}><rect class="g-ink" x="88" y="60" width="24" height="12" rx="2"/><circle class="g-ink" cx="100" cy="42" r="21"/><circle cx="92" cy="35" r="5" fill="#fff" opacity=".2"/></g>`;
}
function bottle(p, big = false, opts = {}) {
  const h = hash(p.b + p.t), id = "vdc" + (++uid);
  const tint = TINTS[h % TINTS.length];
  const b = p.b || "";
  const label = (b.split(" ")[0] === "Van" ? "VAN CLEEF" : b.length > 12 ? b.split(" ")[0] : b).toUpperCase();
  const lab = `<text class="g-text" x="100" text-anchor="middle" font-size="8" letter-spacing="1.6"`;
  if (p.c === "Gift set") {
    return `<svg viewBox="0 0 200 250" aria-hidden="true"><ellipse class="g-shadow" cx="100" cy="236" rx="66" ry="6"/><rect class="g-box" x="40" y="72" width="120" height="160" rx="4"/><rect class="g-garnet" x="94" y="72" width="12" height="160"/><rect class="g-garnet" x="40" y="128" width="120" height="12"/><path d="M100 72c-10-18-30-20-30-8s20 8 30 8c10 0 30 4 30-8s-20-10-30 8z" fill="none" stroke="var(--garnet)" stroke-width="5"/><rect class="g-label" x="54" y="180" width="34" height="28" rx="2"/>${lab.replace('x="100"', 'x="71"')} y="197" font-size="6">${esc(label.slice(0, 7))}</text></svg>`;
  }
  if (isBody(p)) {
    return `<svg viewBox="0 0 200 250" aria-hidden="true"><ellipse class="g-shadow" cx="100" cy="236" rx="44" ry="5"/><path class="g-glass" d="M70 44h60l-6 150H76z"/><path d="M70 44h60l-6 150H76z" fill="${tint}" opacity=".45"/><rect class="g-ink" x="72" y="194" width="56" height="38" rx="5"/><rect class="g-label" x="80" y="100" width="40" height="46" rx="2"/>${lab} y="126" font-size="6.5">${esc(label.slice(0, 9))}</text><rect x="78" y="56" width="5" height="120" fill="#fff" opacity=".5"/></svg>`;
  }
  const shape = h % 4, capType = (h >> 4) % 3, promo = p.k === "Promotional";
  let body, ny, top, bot = 230, left, right, neckW = 24;
  if (shape === 0) { body = `M58 92h84q8 0 8 8v122q0 8-8 8H58q-8 0-8-8V100q0-8 8-8z`; ny = 76; top = 92; left = 50; right = 150; neckW = 28; }
  else if (shape === 1) { body = `M100 104a63 63 0 1 1-.1 0z`; ny = 90; top = 104; left = 37; right = 163; bot = 230; }
  else if (shape === 2) { body = `M68 96h64l22 22v90l-22 22H68l-22-22v-90z`; ny = 80; top = 96; left = 46; right = 154; neckW = 28; }
  else { body = `M94 86h12q26 0 26 26v92q0 26-26 26H94q-26 0-26-26v-92q0-26 26-26z`; ny = 72; top = 86; left = 68; right = 132; }
  const ml = p.ml || 100, s = opts.scale ?? (ml <= 30 ? .8 : ml <= 60 ? .9 : 1);
  const lvl = top + (bot - top) * (.18 + (h % 7) / 50);
  const mid = (top + bot) / 2 + 6;
  const lw = Math.min(64, (right - left) - 28);
  const ls = label.length > 8 ? 1 : 1.6, fs = Math.max(4.2, Math.min(8, ((lw - 8) / Math.max(1, label.length) - ls) / .72));
  const neck = `<rect class="g-glass" x="${100 - neckW / 2}" y="${ny}" width="${neckW}" height="${top - ny + 2}" rx="2"/>`;
  const head = promo
    ? `<rect class="g-metal" x="89" y="${ny - 11}" width="22" height="12" rx="2"/><rect class="g-metal" x="95" y="${ny - 20}" width="10" height="10" rx="2"/><rect class="g-ink" x="104" y="${ny - 17}" width="4" height="3"/>`
    : capSVG(capType, ny);
  return `<svg viewBox="0 0 200 250" aria-hidden="true"${big ? ' class="big"' : ""}><defs><clipPath id="${id}"><path d="${body}"/></clipPath></defs>
<g transform="translate(100 232) scale(${s}) translate(-100 -232)">
<ellipse class="g-shadow" cx="100" cy="236" rx="${(right - left) / 2 + 6}" ry="6"/>
${neck}${head}
<path class="g-glass" d="${body}"/>
<g clip-path="url(#${id})">${opts.wave ? `<g class="liq"><path class="wave" d="M-200 ${lvl}${" q25 -5 50 0 t50 0".repeat(6)} V260 H-200Z" fill="${tint}" opacity=".5"/></g>` : `<rect class="liq" x="0" y="${lvl}" width="200" height="200" fill="${tint}" opacity=".5"/>`}<rect x="${left + 9}" y="${top + 10}" width="6" height="${(bot - top) * .62}" rx="3" fill="#fff" opacity=".55"/></g>
<path class="g-line" d="${body}"/>
${opts.nolabel || !label ? "" : `<rect class="g-label" x="${100 - lw / 2}" y="${mid - 13}" width="${lw}" height="26" rx="1.5"/>
${lab.replace('letter-spacing="1.6"', `letter-spacing="${ls}"`)} y="${mid + 3}" font-size="${fs}">${esc(label)}</text>`}
</g></svg>`;
}
const photo = p => `<img src="${esc(p.img)}" alt="${esc(p.b + " " + p.t)}" loading="lazy">`;
const media = (p, big = false, opts = {}) => p.img ? photo(p) : bottle(p, big, opts);
function nest(svg, x, y, w, h) { return svg.replace('<svg viewBox="0 0 200 250" aria-hidden="true"', `<svg x="${x}" y="${y}" width="${w}" height="${h}" viewBox="0 0 200 250"`); }
function packSVG(p) {
  const promo = p.k === "Promotional";
  const brand = esc(p.b.toUpperCase());
  const fs = Math.max(6, Math.min(12, 84 / (Math.max(1, p.b.length) * .82)));
  const box = promo
    ? `<rect x="86" y="36" width="106" height="192" rx="3" fill="#E7DCC9" stroke="var(--glass-stroke)" stroke-width="1.4"/><path d="M86 52h106" stroke="#CDBFA8"/><g transform="rotate(-9 139 118)"><rect x="95" y="104" width="88" height="26" rx="2" fill="none" stroke="#7B1B2A" stroke-width="1.8"/><text x="139" y="121" text-anchor="middle" font-size="8.6" letter-spacing="1.3" fill="#7B1B2A" font-family="Jost, sans-serif" font-weight="600">PROMOTIONAL</text></g><text x="139" y="212" text-anchor="middle" font-size="7" letter-spacing="1.4" fill="#6b5f50" font-family="Jost, sans-serif">${brand.slice(0, 18)}</text>`
    : `<rect class="g-box" x="86" y="36" width="106" height="192" rx="3"/><rect class="g-garnet" x="86" y="36" width="106" height="16"/><text class="g-text" x="139" y="120" text-anchor="middle" font-size="${fs}" letter-spacing="1.8">${brand}</text><path d="M119 132h40" stroke="var(--garnet)" stroke-width="1.2"/>${p.ml ? `<text class="g-text" x="139" y="212" text-anchor="middle" font-size="8" letter-spacing="1">${mlText(p.ml)} e</text>` : ""}`;
  return `<svg viewBox="0 0 200 250" aria-hidden="true"><ellipse class="g-shadow" cx="118" cy="236" rx="80" ry="6"/>${box}${nest(bottle(p), 0, 74, 132, 165)}</svg>`;
}
function sizeSVG(p) {
  let sizes = [30, 50, 100]; if (p.ml && !sizes.includes(p.ml)) sizes.push(p.ml);
  sizes.sort((a, b) => a - b); if (sizes.length > 3) sizes = sizes.filter(s => s === p.ml || s !== 50);
  const max = Math.max(...sizes), W = 150 * sizes.length;
  return `<svg viewBox="0 0 ${W} 284" aria-hidden="true">${sizes.map((s, i) => {
    const cur = s === p.ml;
    return nest(bottle({ ...p, ml: s }, false, { scale: Math.cbrt(s / max), nolabel: !cur }), i * 150 - 25, 0, 200, 250) +
      `<text x="${i * 150 + 75}" y="270" text-anchor="middle" font-size="14" font-family="Jost, sans-serif" ${cur ? 'fill="var(--garnet)" font-weight="600"' : 'fill="var(--muted)"'}>${mlText(s)}${cur ? " (this one)" : ""}</text>`;
  }).join("")}</svg>`;
}
/* Server-rendered placeholders: <span data-bottle data-b="Dior" data-t="..." data-c="..." data-ml="100" data-k="Promotional" data-opts="big wave nolabel"> */
function fromDataset(d) { return { b: d.b || "", t: d.t || "", c: d.c || "", ml: d.ml ? parseFloat(d.ml) : null, k: /promo/i.test(d.k || "") ? "Promotional" : "Perfume" }; }
function hydrateBottles(root = document) {
  $$("[data-bottle]:not([data-done])", root).forEach(el => {
    const o = (el.dataset.opts || "").split(/\s+/);
    el.outerHTML = bottle(fromDataset(el.dataset), o.includes("big"), { wave: o.includes("wave"), nolabel: o.includes("nolabel") });
  });
}

/* ---------- small renderers ---------- */
const codeLabel = e => /^\d{8,14}$/.test(e) ? "EAN" : "Stock code";
const AVAIL = `<span class="avail"><i aria-hidden="true"></i>In stock</span>`;
const SOLD = `<span class="avail" style="opacity:.7">Sold out</span>`;
const priceHTML = p => p.price != null ? `<span class="price">${money(p.price)}</span>` : `<span class="price req">Price on request</span>`;
const HEART = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.2a4.3 4.3 0 0 1 7.5 2.6C19.5 15.4 12 20 12 20Z"/></svg>`;
const BAG = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M5 8h14l-1 12H6L5 8Z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>`;
const CHECK = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>`;
const addLabel = inB => inB ? `${CHECK}<span>${T.inBag}</span>` : `${BAG}<span>Add<span class="t-long">${T.addLong}</span></span>`;
const badgeHTML = p => p.c === "Gift set" ? `<span class="badge set">Gift set</span>` : p.k === "Promotional" ? `<span class="badge">Promotional</span>` : "";
function addButton(p) {
  if (!p.q) return `<span class="add" style="opacity:.55;cursor:default">Sold out</span>`;
  if (!canBuy(p)) return `<a class="add flash" href="${esc(p.u)}" style="text-decoration:none">Ask about it</a>`;
  const inBag = bag.has(p.id);
  return `<button class="add flash${inBag ? " in" : ""}" data-add="${esc(p.id)}">${addLabel(inBag)}</button>`;
}
function card(p, o = {}) {
  const saved = wish.has(p.id), href = esc(p.u);
  const cls = ["card", o.na ? "na" : "", o.reveal ? "reveal" : ""].filter(Boolean).join(" ");
  const style = o.i != null ? ` style="--i:${o.i};--d:${(o.i * .06).toFixed(2)}s"` : "";
  return `<article class="${cls}"${style}>
  <a class="media stage" href="${href}" tabindex="-1" aria-hidden="true"><span class="spot"></span>${o.motes ? motes(5, p.id) : ""}${media(p)}${badgeHTML(p)}</a>
  <button class="wish" data-wish="${esc(p.id)}" aria-pressed="${saved}" aria-label="Save ${esc(p.b + " " + p.t)}">${HEART}</button>
  <div class="card-body">
    <p class="c-brand">${esc(p.b)}</p>
    <h3 class="c-title"><a href="${href}" style="text-decoration:none">${esc(p.t)}</a></h3>
    <p class="meta"><span>${esc(p.c)}</span>${p.ml ? `<span>${mlText(p.ml)}</span>` : ""}</p>
    <div class="c-foot">${priceHTML(p)}</div>
    ${addButton(p)}
  </div>
</article>`;
}
function motes(n, seed) {
  if (reduced) return "";
  let h = 0;
  return `<span class="motes" aria-hidden="true">${Array.from({ length: n }, (_, k) => {
    h = hash(seed + ":" + k);
    return `<i class="mote" style="left:${25 + h % 50}%;--t:${7 + h % 6}s;--dl:${((h >> 3) % 70) / 10}s;--sx:${(h % 2 ? 1 : -1) * (6 + h % 14)}px"></i>`;
  }).join("")}</span>`;
}

/* ---------- bag: enquiry list in local storage, or the real Shopify cart ---------- */
function fromCartItem(it) {
  return prep({ h: it.handle, b: it.vendor, t: it.product_title, c: it.product_type, v: it.variant_id, pr: it.price, q: 99, a: true, e: it.sku, img: it.image, u: it.url, tg: [] });
}
class LocalBag {
  constructor() { this.m = new Map(store.get("bag", [])); }
  async sync() { for (const [id, n] of [...this.m]) { const p = byId.get(id); if (ALL.length && (!p || !p.q)) this.m.delete(id); else if (p && n > p.q) this.m.set(id, p.q); } this.save(); }
  has(id) { return this.m.has(id); }
  get(id) { return this.m.get(id) || 0; }
  units() { return [...this.m.values()].reduce((a, b) => a + b, 0); }
  lines() { return [...this.m].map(([id, n]) => ({ id, n, p: byId.get(id) })).filter(l => l.p); }
  async add(p, n) { this.m.set(p.id, Math.min(p.q, this.get(p.id) + n)); this.save(); }
  async set(p, n) { if (n <= 0) this.m.delete(p.id); else this.m.set(p.id, n); this.save(); }
  async remove(p) { this.m.delete(p.id); this.save(); }
  async clear() { this.m.clear(); this.save(); }
  save() { store.set("bag", [...this.m]); }
}
class CartBag {
  constructor() { this.items = []; }
  async sync() {
    try { const r = await fetch(VD.cart + ".js", { credentials: "same-origin", headers: { Accept: "application/json" } }); this.cart = await r.json(); this.items = this.cart.items || []; } catch { this.items = []; }
  }
  has(id) { return this.items.some(it => it.handle === id); }
  get(id) { return this.items.filter(it => it.handle === id).reduce((a, it) => a + it.quantity, 0); }
  units() { return this.items.reduce((a, it) => a + it.quantity, 0); }
  lines() { return this.items.map(it => ({ id: it.handle, n: it.quantity, key: it.key, p: byId.get(it.handle) || fromCartItem(it), line: it.final_line_price })); }
  async post(url, body) {
    const r = await fetch(url + ".js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) });
    if (!r.ok) { const j = await r.json().catch(() => ({})); const e = new Error(j.description || j.message || "Couldn’t update the bag"); e.shop = true; throw e; }
    await this.sync();
  }
  async add(p, n) { await this.post(VD.cartAdd, { items: [{ id: p.v, quantity: n }] }); }
  async set(p, n) { const it = this.items.find(x => x.handle === p.id); if (it) await this.post(VD.cartChange, { id: it.key, quantity: n }); }
  async remove(p) { return this.set(p, 0); }
  async clear() { await this.post(VD.cart + "/clear", {}); }
}
const bag = CHECKOUT ? new CartBag() : new LocalBag();
const wish = new Set(store.get("wish", []));

/* ---------- reveal, count-up, fly-to-bag ---------- */
const io = "IntersectionObserver" in window
  ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } }), { rootMargin: "0px 0px -8% 0px", threshold: .05 })
  : null;
function observe(root = document) { $$(".reveal:not(.in)", root).forEach(el => io ? io.observe(el) : el.classList.add("in")); }
function countUp(el, to) {
  if (reduced) { el.textContent = to; return; }
  const t0 = performance.now() + 300, dur = 1300;
  const tick = now => { const k = Math.min(1, Math.max(0, (now - t0) / dur)); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(tick); };
  el.textContent = 0; requestAnimationFrame(tick);
}
function bump(el) { if (!el || reduced) return; el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump"); }
function flyToBag(from) {
  const target = $("#bag-btn svg");
  if (reduced || !from || !target) { bump($("#bag-count")); return; }
  const r = from.getBoundingClientRect(), t = target.getBoundingClientRect();
  const x0 = r.left + r.width / 2 - 8, y0 = r.top + r.height / 2 - 8;
  const dx = t.left + t.width / 2 - 8 - x0, dy = t.top + t.height / 2 - 8 - y0;
  const d = document.createElement("div"); d.className = "fly"; document.body.appendChild(d);
  const a = d.animate([
    { transform: `translate(${x0}px,${y0}px) scale(.6)`, opacity: 0 },
    { transform: `translate(${x0 + dx * .45}px,${Math.max(10, y0 + dy * .55 - 70)}px) scale(1.25)`, opacity: 1, offset: .45 },
    { transform: `translate(${x0 + dx}px,${y0 + dy}px) scale(.45)`, opacity: .85 }
  ], { duration: 750, easing: "cubic-bezier(.45,0,.25,1)" });
  a.onfinish = () => { d.remove(); bump($("#bag-count")); bump($("#bag-btn svg")); };
}

/* ---------- toast, copy, low-stock pop-up ---------- */
let tt;
function toast(msg, withBtn) {
  const el = $("#toast"); if (!el) return;
  $("#toast-msg").textContent = msg; $("#toast-btn").hidden = !withBtn;
  el.classList.add("on"); clearTimeout(tt); tt = setTimeout(() => el.classList.remove("on"), 3200);
}
async function copy(text, okMsg) {
  try { await navigator.clipboard.writeText(text); toast(okMsg); }
  catch { const ta = document.createElement("textarea"); ta.value = text; document.body.appendChild(ta); ta.select(); try { document.execCommand("copy"); toast(okMsg); } catch { toast("Copy isn’t available here. Select the text manually."); } ta.remove(); }
}
let popFocus = null;
function popup(msg, showBag) {
  $("#pop-msg").textContent = msg;
  $("#pop-bag").hidden = !showBag || $("#drawer").classList.contains("on");
  popFocus = document.activeElement;
  $("#pop").hidden = false; $("#pop-ok").focus();
}
function lowStock(p) {
  const inB = bag.get(p.id), room = p.q - inB, one = p.q === 1;
  const have = one ? "We only have one bottle of this perfume" : `We only have ${p.q} bottles of this perfume`;
  popup(room <= 0 ? `${have}, and ${one ? "it’s" : "they’re all"} already in your ${T.list}.`
    : inB ? `${have}, and ${inB} ${inB === 1 ? "is" : "are"} already in your ${T.list}. You can add ${room} more.`
    : `${have}, so you can’t add more than that.`, inB > 0);
}
function closePop() { if ($("#pop").hidden) return; $("#pop").hidden = true; popFocus?.focus?.({ preventScroll: true }); }

/* ---------- bag drawer ---------- */
function lineText(p, n) { return `${n} × ${p.b} ${p.t}, ${p.c}${p.ml ? " " + mlText(p.ml) : ""}, ${packText(p).toLowerCase()}${p.e ? ` (${codeLabel(p.e)} ${p.e})` : ""}`; }
function enquiryText(lines) { return `Hello ${VD.shopName},\n\nI’d like to check availability and prices for:\n\n${lines.map(l => "• " + lineText(l.p, l.n)).join("\n")}\n\nThank you.`; }
const waLink = t => `https://wa.me/${VD.whatsapp}?text=${encodeURIComponent(t)}`;
const mailLink = (t, subj) => `mailto:${VD.email}?subject=${encodeURIComponent(subj)}&body=${encodeURIComponent(t)}`;
function saveCounts() {
  const n = bag.units(), c = $("#bag-count"); if (c) { c.textContent = n; c.hidden = !n; }
  const w = $("#saved-count"); if (w) { w.textContent = wish.size; w.hidden = !wish.size; }
  store.set("wish", [...wish]);
}
function bagLinesHTML(lines) {
  return lines.map(({ p, n, line }) => `<div class="line">
    <a class="media" href="${esc(p.u)}" tabindex="-1" aria-hidden="true">${p.img ? photo(p) : bottle(p)}</a>
    <div><p class="c-brand">${esc(p.b)}</p><p class="c-title"><a href="${esc(p.u)}" style="text-decoration:none">${esc(p.t)}</a></p>
    <p class="meta"><span>${esc(p.c)}</span>${p.ml ? `<span>${mlText(p.ml)}</span>` : ""}<span>${packText(p)}</span></p>
    <div class="line-row"><span class="step"><button data-dec="${esc(p.id)}" aria-label="One fewer"${n <= 1 ? " disabled" : ""}>−</button><output aria-live="polite">${n}</output><button data-inc="${esc(p.id)}" aria-label="One more">+</button></span>
    ${CHECKOUT && line != null ? `<span class="price">${money(line)}</span>` : p.price != null ? `<span class="price">${money(p.price * n)}</span>` : ""}<button class="rm" data-rm="${esc(p.id)}">Remove</button></div>
    </div></div>`).join("");
}
function renderBag() {
  const lines = bag.lines();
  const targets = [["#bag-body", "#bag-foot", "#bag-sum"], ["#cart-lines", "#cart-foot", "#cart-sum"]].filter(([b]) => $(b));
  for (const [b, f, s] of targets) {
    const body = $(b), foot = $(f);
    if (!lines.length) {
      body.innerHTML = `<div class="d-empty"><h3>${T.empty}</h3><p>${CHECKOUT ? "Add bottles from the shelf, then check out in one go." : "Add bottles from the shelf, then send the whole list in one message."}</p><a class="btn btn-primary" href="${esc(VD.shelf)}">Browse the shelf</a></div>`;
      foot.hidden = true; continue;
    }
    body.innerHTML = bagLinesHTML(lines);
    foot.hidden = false;
    const units = lines.reduce((a, l) => a + l.n, 0);
    const priced = lines.every(l => l.p.price != null);
    const total = CHECKOUT && bag.cart ? bag.cart.total_price : lines.reduce((a, l) => a + (l.p.price || 0) * l.n, 0);
    $(s).innerHTML = `<span>${units} ${units === 1 ? "bottle" : "bottles"}, ${lines.length} ${lines.length === 1 ? "reference" : "references"}</span>${CHECKOUT || priced ? `<b>${money(total)}</b>` : `<span style="color:var(--muted)">Prices on request</span>`}`;
  }
  if (!CHECKOUT && lines.length) {
    const text = enquiryText(lines);
    $$("[data-wa-enquiry]").forEach(a => { a.href = waLink(text); });
    $$("[data-mail-enquiry]").forEach(a => { a.href = mailLink(text, `Enquiry: ${lines.reduce((a, l) => a + l.n, 0)} bottles`); });
  }
}
let lastFocus = null;
function openBag() {
  const d = $("#drawer"); if (!d) return;
  lastFocus = document.activeElement; renderBag();
  d.classList.add("on"); d.setAttribute("aria-hidden", "false"); $("#scrim").classList.add("on"); $("#bag-close").focus();
}
function closeBag(restore = true) {
  const d = $("#drawer"); if (!d) return;
  d.classList.remove("on"); d.setAttribute("aria-hidden", "true");
  if (!$("#filters")?.classList.contains("on")) $("#scrim").classList.remove("on");
  if (restore) lastFocus?.focus?.({ preventScroll: true });
}
function refreshCards(id) {
  $$(`.card [data-add="${CSS.escape(id)}"]`).forEach(b => { const inB = bag.has(id); b.classList.toggle("in", inB); b.innerHTML = addLabel(inB); });
  $$(`[data-wish="${CSS.escape(id)}"]`).forEach(b => b.setAttribute("aria-pressed", wish.has(id)));
}
async function addToBag(id, qty = 1, from) {
  const p = byId.get(id); if (!p) return;
  const cur = bag.get(id);
  if (cur + qty > p.q) { if (cur >= p.q) { lowStock(p); return; } qty = p.q - cur; }
  try { await bag.add(p, qty); }
  catch (e) { popup(e.shop ? e.message : "Something went wrong. Please try again.", bag.units() > 0); return; }
  saveCounts(); refreshCards(id); flyToBag(from);
  toast(T.added, true);
  if ($("#drawer").classList.contains("on") || $("#cart-lines")) renderBag();
  if (PP.p && PP.p.id === id) updPP();
}

/* ---------- shelf: filters, chips, grid ---------- */
const GROUPS = [
  { key: "g", param: "for", label: "For", opts: [["Women", "Women"], ["Men", "Men"], ["Infants", "Infants"], ["Unisex", "Unisex"]] },
  { key: "k", param: "pack", label: "Packaging", opts: [["Perfume", "Boxed bottle"], ["Promotional", "Promotional"]] },
  { key: "c", param: "type", label: "Type", opts: [["Eau de Parfum", "Eau de Parfum"], ["Eau de Toilette", "Eau de Toilette"], ["Parfum", "Parfum"], ["Eau de Cologne", "Eau de Cologne"], ["Fragrance mist", "Fragrance mist"], ["Alcohol-free", "No alcohol"], ["Gift set", "Gift set"], ["Body & grooming", "Body & grooming"], ["Bathline", "Bathline"], ["After shave", "After shave"]] },
  { key: "sz", param: "size", label: "Size", opts: [["S", "Up to 30 ml"], ["M", "31–75 ml"], ["L", "76–100 ml"], ["XL", "Over 100 ml"]] }
];
const PACK_IN = v => /promo|tester/i.test(v) ? "Promotional" : /box|perfume/i.test(v) ? "Perfume" : null;
const PACK_OUT = v => v === "Promotional" ? "promotional" : "boxed";
const blank = () => ({ q: "", g: new Set(), k: new Set(), c: new Set(), sz: new Set(), b: new Set(), saved: false, sort: "brand", shown: 24 });
let S = blank(), SHELF = null; // SHELF = list the shelf section filters (whole catalogue or one collection)
const PRESTIGE = (VD.prestige && VD.prestige.length ? VD.prestige : ["Chanel", "Hermès", "Houbigant", "Dior", "Cartier", "Guerlain", "Van Cleef & Arpels", "Bvlgari", "Yves Saint Laurent", "Gucci", "Givenchy", "Lancôme", "Loewe", "Estée Lauder", "Balenciaga", "Miu Miu"]);
const rank = b => { const i = PRESTIGE.indexOf(b); return i < 0 ? 99 : i; };
const byName = (x, y) => norm(x.b).localeCompare(norm(y.b)) || norm(x.t).localeCompare(norm(y.t)) || (x.ml || 0) - (y.ml || 0);
function matches(p, skip) {
  if (S.q) { const terms = norm(S.q).split(/\s+/).filter(Boolean); if (!terms.every(t => p.s.includes(t))) return false; }
  for (const g of ["g", "k", "c", "sz", "b"]) if (g !== skip && S[g].size && !S[g].has(p[g])) return false;
  if (S.saved && !wish.has(p.id)) return false;
  return true;
}
function sorted(list) {
  const a = [...list], pr = x => x.price ?? Infinity;
  switch (S.sort) {
    case "size-asc": return a.sort((x, y) => (x.ml ?? 999) - (y.ml ?? 999) || byName(x, y));
    case "size-desc": return a.sort((x, y) => (y.ml ?? -1) - (x.ml ?? -1) || byName(x, y));
    case "price-asc": return a.sort((x, y) => pr(x) - pr(y) || byName(x, y));
    case "price-desc": return a.sort((x, y) => (y.price ?? -1) - (x.price ?? -1) || byName(x, y));
    default: return a.sort(byName);
  }
}
function readURL() {
  const u = new URLSearchParams(location.search), s = blank();
  u.getAll("for").forEach(v => s.g.add(cap(v)));
  u.getAll("pack").forEach(v => { const k = PACK_IN(v); if (k) s.k.add(k); });
  u.getAll("type").forEach(v => s.c.add(v));
  u.getAll("size").forEach(v => s.sz.add(v.toUpperCase()));
  u.getAll("brand").forEach(v => s.b.add(v));
  s.q = u.get("q") || "";
  s.saved = u.get("saved") === "1";
  if (u.get("sort")) s.sort = u.get("sort");
  return s;
}
function writeURL() {
  const u = new URLSearchParams(location.search);
  ["for", "pack", "type", "size", "brand", "q", "saved", "sort", "page"].forEach(k => u.delete(k));
  S.g.forEach(v => u.append("for", v)); S.k.forEach(v => u.append("pack", PACK_OUT(v)));
  S.c.forEach(v => u.append("type", v)); S.sz.forEach(v => u.append("size", v)); S.b.forEach(v => u.append("brand", v));
  if (S.q) u.set("q", S.q); if (S.saved) u.set("saved", "1"); if (S.sort !== "brand") u.set("sort", S.sort);
  const s = u.toString();
  history.replaceState(history.state, "", location.pathname + (s ? "?" + s : "") + location.hash);
}
function renderFilters() {
  $("#f-groups").innerHTML = GROUPS.map(g => {
    const counts = {}; for (const p of SHELF) if (matches(p, g.key)) counts[p[g.key]] = (counts[p[g.key]] || 0) + 1;
    if (g.key === "c" && !g.opts.some(([v]) => counts[v] || S.c.has(v))) return "";
    return `<fieldset><legend>${g.label}</legend>${g.opts.map(([v, l]) => {
      const n = counts[v] || 0, on = S[g.key].has(v);
      if (g.key === "c" && !n && !on) return "";
      return `<label class="opt${n || on ? "" : " zero"}"><input type="checkbox" data-f="${g.key}" value="${esc(v)}"${on ? " checked" : ""}><span>${esc(l)}</span><span class="k">${n}</span></label>`;
    }).join("")}</fieldset>`;
  }).join("");
  const counts = {}; for (const p of SHELF) if (matches(p, "b")) counts[p.b] = (counts[p.b] || 0) + 1;
  const bq = norm($("#bsearch").value || "");
  const houses = [...new Set(SHELF.map(p => p.b))].sort((a, b) => norm(a).localeCompare(norm(b)));
  const list = houses.filter(b => !bq || norm(b).includes(bq)).sort((a, b) => (S.b.has(b) ? 0 : 1) - (S.b.has(a) ? 0 : 1));
  $("#blist").innerHTML = list.map(b => {
    const n = counts[b] || 0, on = S.b.has(b);
    return `<label class="opt${n || on ? "" : " zero"}"><input type="checkbox" data-f="b" value="${esc(b)}"${on ? " checked" : ""}><span>${esc(b)}</span></label>`;
  }).join("") || `<p style="font-size:14px;color:var(--muted);padding:6px 0">No brand matches “${esc($("#bsearch").value)}”.</p>`;
}
function renderChips() {
  const chips = [];
  const X = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M7 7l10 10M17 7 7 17"/></svg>`;
  if (S.q) chips.push([`Search: “${S.q}”`, "q", ""]);
  if (S.saved) chips.push(["Saved only", "saved", ""]);
  for (const g of GROUPS) for (const v of S[g.key]) chips.push([g.opts.find(o => o[0] === v)?.[1] || v, g.key, v]);
  for (const v of S.b) chips.push([v, "b", v]);
  $("#chips").innerHTML = chips.map(([l, k, v]) => `<button class="chip" data-chip="${k}" data-v="${esc(v)}" aria-label="Remove filter ${esc(l)}">${esc(l)}${X}</button>`).join("") + (chips.length > 1 ? `<button class="chip clear" data-chip="all">Clear all</button>` : "");
}
function render(keepShown) {
  if (!SHELF) return;
  const prev = keepShown ? $$("#grid .card").length : 0;
  if (!keepShown) S.shown = 24;
  const list = sorted(SHELF.filter(p => matches(p)));
  const show = list.slice(0, S.shown);
  const noInfants = !show.length && S.g.size === 1 && S.g.has("Infants") && !SHELF.some(p => p.g === "Infants");
  const nl = $("#newsletter") ? "#newsletter" : join(VD.root, "#newsletter");
  $("#grid").innerHTML = show.length ? show.map((p, i) => card(p, { i: Math.min(Math.max(0, i - prev), 12), na: i < prev })).join("") :
    noInfants ? `<div class="empty"><h3>Infant fragrances are on their way</h3><p>There’s nothing on this shelf yet. Join the new arrivals list and we’ll email you when they land.</p><div class="cta-row" style="justify-content:center;margin-top:0"><a class="btn btn-primary" href="${nl}">Join the list</a><button class="btn btn-ghost" data-chip="all">Browse the shelf</button></div></div>` :
    `<div class="empty"><h3>No bottles match these filters</h3><p>${S.saved && !wish.size ? "You haven’t saved any perfumes yet. Tap the heart on a bottle to keep it here." : "Remove a filter or try a shorter search, such as the brand name only."}</p><button class="btn btn-ghost" data-chip="all">Clear all filters</button></div>`;
  $("#res").innerHTML = `<b>${list.length}</b> ${list.length === 1 ? "reference" : "references"}`;
  const rest = list.length - show.length;
  $("#more").innerHTML = rest > 0 ? `<span>Showing ${show.length} of ${list.length}</span><button class="btn btn-ghost" id="more-btn">Show ${Math.min(24, rest)} more</button>` : "";
  $("#f-apply").textContent = `Show ${list.length} ${list.length === 1 ? "result" : "results"}`;
  renderFilters(); renderChips(); syncNav();
}
function syncNav() {
  if (!SHELF) return;
  const one = (set, v) => set.size === 1 && set.has(v);
  const plain = !S.q && !S.sz.size && !S.saved && S.k.size <= 1 && !S.c.size;
  const cur = !plain ? "" : !S.b.size && S.g.size === 1 ? [...S.g][0].toLowerCase() : !S.g.size && S.b.size === 1 ? "brands" : "";
  $$("nav.main a[data-route]").forEach(a => a.setAttribute("aria-current", a.dataset.route === cur ? "true" : "false"));
}
function shelfJump() { requestAnimationFrame(() => $("#shop")?.scrollIntoView({ behavior: smooth() })); }
function closeFilters() { $("#filters")?.classList.remove("on"); if (!$("#drawer")?.classList.contains("on")) $("#scrim")?.classList.remove("on"); }
function initShelf(list) {
  SHELF = list;
  const sel = $("#sort"); if (!P.some(p => p.price != null)) $$("option[data-price]", sel).forEach(o => o.remove());
  S = readURL();
  if (!$(`option[value="${CSS.escape(S.sort)}"]`, sel)) S.sort = "brand";
  sel.value = S.sort; $$("#q,#q2").forEach(i => { i.value = S.q; });
  render();
  if (location.search && $("#shop").dataset.home === "true") shelfJump();
  $("#bsearch").addEventListener("input", renderFilters);
  $("#f-open").addEventListener("click", () => { $("#filters").classList.add("on"); $("#scrim").classList.add("on"); $("#f-close").focus(); });
  $("#f-close").addEventListener("click", closeFilters);
  $("#f-apply").addEventListener("click", () => { closeFilters(); shelfJump(); });
}

/* ---------- product page ---------- */
let PP = { p: null, n: 1, view: "bottle" };
function siblings(p) { return ALL.filter(o => o.b === p.b && norm(o.t) === norm(p.t) && (visible(o) || o.id === p.id)).sort((a, b) => (a.ml || 0) - (b.ml || 0) || (a.k === "Promotional") - (b.k === "Promotional") || a.id.localeCompare(b.id)); }
function similar(p) {
  const pool = P.filter(o => o.b !== p.b && o.g === p.g && (o.c === p.c || o.k === p.k));
  return pool.sort((a, b) => (rank(a.b) < 99 ? 0 : 1) - (rank(b.b) < 99 ? 0 : 1) || hash(p.id + ":" + a.id) - hash(p.id + ":" + b.id)).slice(0, 8);
}
const ICON_INFO = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5v.5"/></svg>`;
function stageHTML(p, view) {
  const html = view === "pack" ? packSVG(p) : view === "size" ? sizeSVG(p) : bottle(p, true, { wave: true });
  return `<div class="pp-shot${view === "size" ? " wide" : ""}">${html}</div>`;
}
function updPP() {
  const p = PP.p; if (!p) return;
  const room = p.q - bag.get(p.id);
  PP.n = Math.max(1, Math.min(PP.n, Math.max(1, room)));
  const out = $("#pp-n"); if (!out) return;
  out.textContent = PP.n;
  $("[data-pdec]").disabled = PP.n <= 1;
  const full = room <= 0;
  $$("[data-padd]").forEach(b => {
    if (!p.q) { b.disabled = true; b.textContent = "Sold out"; return; }
    b.innerHTML = full ? `${CHECK}${b.id === "pp-add-bar" ? T.inShort : T.inBag}` : `${b.id === "pp-add-bar" ? "" : BAG}${T.add}`;
  });
}
function initProduct(root) {
  const d = root.dataset;
  const base = prep({ h: d.handle, b: d.b, t: d.t, c: d.c, v: +d.v, pr: +d.pr, q: +d.q, a: d.a === "true", e: d.e, img: d.img, u: location.pathname, tg: JSON.parse(d.tags || "[]") });
  PP = { p: base, n: 1, view: "bottle" };
  const stage = $("#pp-stage");
  const plain = base.c === "Gift set" || isBody(base);
  if (stage && !stage.querySelector("img")) {
    stage.insertAdjacentHTML("afterbegin", motes(8, base.id));
    stage.insertAdjacentHTML("beforeend", stageHTML(base, "bottle"));
    const th = $("#pp-thumbs");
    const views = plain ? [] : [["bottle", "Bottle", bottle(base)], ["pack", "Packaging", packSVG(base)], ...(base.ml ? [["size", "Size guide", sizeSVG(base)]] : [])];
    if (th && views.length) { th.innerHTML = views.map(([k, l, svg], i) => `<button role="tab" data-view="${k}" aria-selected="${i === 0}"><span class="th">${svg}</span>${l}</button>`).join(""); th.hidden = false; }
  }
  updPP();
  /* photo gallery: thumbnails swap the main image */
  $$("[data-img]", root).forEach(b => b.addEventListener("click", () => {
    const img = $("#pp-stage img"); if (!img) return;
    img.src = b.dataset.img; img.srcset = b.dataset.srcset || ""; img.alt = b.dataset.alt || "";
    $$("[data-img]", root).forEach(x => x.setAttribute("aria-selected", x === b));
  }));
}
function enrichProduct() {
  const root = $("[data-product]"); if (!root || !PP.p) return;
  const p = byId.get(PP.p.id) || PP.p; PP.p = p;
  const sib = siblings(p);
  const boxedGone = p.k === "Promotional" && !sib.some(o => o.k !== "Promotional" && o.ml === p.ml);
  const offChip = `<span class="off" aria-disabled="true">${p.ml ? mlText(p.ml) : esc(p.c)}<small>Boxed, out of stock</small></span>`;
  const varChip = o => `<a href="${esc(o.u)}"${o.id === p.id ? ' aria-current="page"' : ""}>${o.ml ? mlText(o.ml) : esc(o.c)}<small>${packText(o)}${o.q ? "" : ", sold out"}</small></a>`;
  const ver = $("#pp-versions");
  if (ver && (sib.length > 1 || boxedGone)) { ver.innerHTML = `<p class="var-h">Versions</p><div class="var">${sib.map(o => (boxedGone && o.id === p.id ? offChip : "") + varChip(o)).join("")}</div>`; ver.hidden = false; }
  if (boxedGone) {
    const n = $("#pp-boxed-note"); if (n) { n.innerHTML = `${ICON_INFO}<span><b>The boxed bottle is discontinued or unavailable.</b> This promotional bottle is the same perfume, and it’s in stock.</span>`; n.hidden = false; }
    const a = $("#pp-boxed-about"); if (a) { a.innerHTML = `${ICON_INFO}<span><b>Boxed version out of stock.</b> The boxed retail bottle of this perfume is discontinued or currently unavailable. We’ve kept the promotional bottle on the shelf so you can still buy it.</span>`; a.hidden = false; }
    $$("[data-boxed-row]").forEach(el => { el.hidden = false; });
  }
  const rails = $("#pp-rails");
  if (rails && rails.dataset.show !== "false") {
    const more = P.filter(o => o.b === p.b && norm(o.t) !== norm(p.t)).sort(byName).slice(0, 8);
    const like = similar(p);
    rails.innerHTML = (more.length ? `<section class="pp-rail"><div class="sec-head reveal"><div><h2>More from ${esc(p.b)}</h2></div><a class="link" href="${esc(houseHref(p.b))}">See all ${P.filter(o => o.b === p.b).length}</a></div><div class="rail">${more.map((o, i) => card(o, { i, reveal: true })).join("")}</div></section>` : "") +
      (like.length ? `<section class="pp-rail"><div class="sec-head reveal"><div><h2>You may also like</h2></div></div><div class="rail">${like.map((o, i) => card(o, { i, reveal: true })).join("")}</div></section>` : "");
    observe(rails);
  }
  updPP();
}

/* ---------- home sections ---------- */
function splitWords(el) {
  el.setAttribute("aria-label", el.textContent.trim());
  el.innerHTML = el.textContent.trim().split(/\s+/).map((w, i) => `<span class="w" aria-hidden="true"><span style="--i:${i}">${esc(w)}</span></span>`).join(" ");
}
function renderStats() {
  const stat = { houses: HOUSES.length, refs: P.length, promo: P.filter(p => p.k === "Promotional").length };
  $$("[data-stat]").forEach(el => el.hasAttribute("data-count") ? countUp(el, stat[el.dataset.stat]) : el.textContent = stat[el.dataset.stat]);
  $$("[data-count-for]").forEach(el => {
    const g = el.dataset.countFor, n = P.filter(p => !g || p.g === g).length;
    el.textContent = n ? `${n} ${el.dataset.noun || "perfumes"}` : (el.dataset.empty || "Coming soon");
  });
}
function renderRare() {
  const rail = $("#rail"); if (!rail) return;
  let pick = [];
  const hs = (rail.dataset.handles || "").split(",").filter(Boolean);
  if (hs.length) pick = hs.map(h => byId.get(h)).filter(p => p && visible(p));
  else {
    const pool = P.filter(p => p.q === 1 && rank(p.b) < 99 && !isBody(p) && p.c !== "Gift set");
    const byB = PRESTIGE.map(b => pool.filter(p => p.b === b).sort((x, y) => norm(x.t).localeCompare(norm(y.t)))).filter(a => a.length);
    const seen = new Set(), max = +rail.dataset.max || 14;
    for (let round = 0; pick.length < max && round < 6; round++) for (const arr of byB) { const p = arr[round]; if (!p || seen.has(p.b + p.t)) continue; seen.add(p.b + p.t); pick.push(p); if (pick.length >= max) break; }
    if (!pick.length) pick = P.filter(p => p.q === 1).slice(0, max);
  }
  rail.innerHTML = pick.map((p, i) => card(p, { i: Math.min(i, 6), reveal: true, motes: true })).join("");
  observe(rail);
}
function renderMega() {
  /* packaging dropdowns under Men / Women / Infants show only the rows that have stock */
  $$("[data-pk-row]").forEach(a => {
    const g = a.dataset.g, k = a.dataset.k, n = P.filter(p => p.g === g && (!k || p.k === k)).length;
    a.hidden = !n; const c = $(".k", a); if (c) c.textContent = n;
  });
}
function initTop() {
  const list = $("#top-list"); if (!list) return;
  const rows = $$(".tp-row", list), shots = $$("#tp-stage .tp-shot");
  if (!rows.length) return;
  let tpCur = -1;
  const two = n => String(n).padStart(2, "0");
  const DG = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(d => `<span>${d}</span>`).join("");
  $("#tp-count").innerHTML = `<span class="tp-dg" id="tp-dg"><span class="tp-d"><span>${DG}</span></span><span class="tp-d"><span>${DG}</span></span></span><span>/ ${two(rows.length)}</span>`;
  $("#tp-stage").insertAdjacentHTML("beforeend", motes(6, 99));
  const restart = (el, cls) => { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); };
  const showTop = k => {
    const row = rows[k]; if (!row || k === tpCur) return;
    const first = tpCur < 0; tpCur = k;
    shots.forEach(el => { const i = +el.dataset.i; el.classList.toggle("on", i === k); el.classList.toggle("past", i < k); });
    rows.forEach(el => el.classList.toggle("on", +el.dataset.i === k));
    two(k + 1).split("").forEach((d, j) => { $$("#tp-dg .tp-d > span")[j].style.transform = `translateY(-${d * 1.2}em)`; });
    $("#tp-brand").textContent = row.dataset.brand; $("#tp-name").textContent = row.dataset.name; $("#tp-line").textContent = row.dataset.line || "";
    if (!first) { restart($("#tp-cap"), "enter"); restart($("#tp-stage"), "flick"); }
    const btn = $("#tp-btn"); btn.href = row.getAttribute("href"); btn.textContent = row.dataset.cta || "Shop now";
  };
  $$("li", list).forEach((li, i) => li.style.setProperty("--d", (i % 5 * .07).toFixed(2) + "s"));
  if ("IntersectionObserver" in window) {
    const rio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add("seen"); rio.unobserve(e.target); } }), { rootMargin: "0px 0px -6% 0px" });
    $$("li", list).forEach(li => rio.observe(li));
  } else $$("li", list).forEach(li => li.classList.add("seen"));
  list.insertAdjacentHTML("afterbegin", `<span class="tp-rail" aria-hidden="true"><i></i></span>`);
  let railT = 0;
  const rail = () => { railT = 0; const r = list.getBoundingClientRect(); const p = (innerHeight * .5 - r.top) / r.height; list.style.setProperty("--tp-p", Math.max(0, Math.min(1, p)).toFixed(3)); };
  addEventListener("scroll", () => { if (!railT) railT = requestAnimationFrame(rail); }, { passive: true }); rail();
  showTop(0);
  if ("IntersectionObserver" in window) {
    const tio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) showTop(+e.target.dataset.i); }), { rootMargin: "-48% 0px -48% 0px" });
    rows.forEach(el => tio.observe(el));
  }
  rows.forEach(el => { el.addEventListener("mouseenter", () => showTop(+el.dataset.i)); el.addEventListener("focus", () => showTop(+el.dataset.i)); });
}
function initMarquee() {
  const mq = $("#mq"); if (!mq) return;
  mq.insertAdjacentHTML("beforeend", mq.innerHTML.replace(/<a /g, '<a tabindex="-1" aria-hidden="true" '));
  requestAnimationFrame(() => { const w = mq.scrollWidth / 2; if (w) mq.style.setProperty("--mq-t", Math.round(w / 55) + "s"); });
}

/* ---------- lamps on product stages, and the warm glow that follows the pointer ---------- */
(() => {
  const lamp = "IntersectionObserver" in window
    ? new IntersectionObserver(es => es.forEach(e => {
        if (!e.isIntersecting) return;
        const el = e.target, sibs = [...(el.closest(".rail,.grid,.top") || document).querySelectorAll(".stage")];
        const k = Math.max(0, sibs.indexOf(el)) % 6;
        setTimeout(() => el.classList.add("on"), k * 110);
        lamp.unobserve(el);
      }), { threshold: .35 })
    : null;
  const scan = root => (root.querySelectorAll ? root : document).querySelectorAll(".stage:not(.on)").forEach(el => lamp ? lamp.observe(el) : el.classList.add("on"));
  scan(document);
  new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n => { if (n.nodeType !== 1) return; if (n.matches(".stage:not(.on)")) lamp ? lamp.observe(n) : n.classList.add("on"); scan(n); }))).observe(document.body, { childList: true, subtree: true });
})();
(() => {
  const SEL = ".flash,.btn-primary,.stage", EASE = 0.25;
  const live = new Map();
  let ev = null, raf = 0;
  const chain = t => { const a = []; for (let el = t?.closest?.(SEL); el; el = el.parentElement?.closest(SEL)) a.push(el); return a; };
  const put = (el, p) => { el.style.setProperty("--mx", p.x.toFixed(1) + "px"); el.style.setProperty("--my", p.y.toFixed(1) + "px"); };
  function aim(target, cx, cy, snap) {
    const els = chain(target);
    for (const el of live.keys()) if (!els.includes(el)) live.delete(el);
    for (const el of els) {
      const r = el.getBoundingClientRect(), tx = cx - r.left, ty = cy - r.top;
      let p = live.get(el);
      if (!p || snap || reduced) { p = { x: tx, y: ty, tx, ty }; live.set(el, p); put(el, p); }
      else { p.tx = tx; p.ty = ty; }
    }
  }
  function tick() {
    raf = 0;
    if (ev) { aim(ev.target, ev.clientX, ev.clientY); ev = null; }
    let moving = false;
    for (const [el, p] of live) {
      const dx = p.tx - p.x, dy = p.ty - p.y;
      if (Math.abs(dx) + Math.abs(dy) < .4) { p.x = p.tx; p.y = p.ty; } else { p.x += dx * EASE; p.y += dy * EASE; moving = true; }
      put(el, p);
    }
    if (moving) raf = requestAnimationFrame(tick);
  }
  document.addEventListener("pointermove", e => { if (e.pointerType === "touch") return; ev = e; if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });
  document.addEventListener("pointerdown", e => {
    if (e.pointerType !== "touch") return;
    aim(e.target, e.clientX, e.clientY, true);
    const lit = chain(e.target);
    lit.forEach(el => { el.classList.remove("lit"); void el.offsetWidth; el.classList.add("lit"); });
    setTimeout(() => lit.forEach(el => el.classList.remove("lit")), 800);
  }, { passive: true });
})();

/* ---------- events ---------- */
document.addEventListener("click", async e => {
  const t = e.target.closest("[data-add],[data-wish],[data-chip],[data-rm],[data-inc],[data-dec],[data-open-bag],[data-view],[data-pdec],[data-pinc],[data-padd],[data-copy-link],[data-copy-list],#more-btn");
  if (!t) return;
  if (t.dataset.add != null) { const id = t.dataset.add; if (bag.has(id)) openBag(); else addToBag(id, 1, t); return; }
  if (t.dataset.wish != null) {
    const id = t.dataset.wish; wish.has(id) ? wish.delete(id) : wish.add(id); saveCounts(); refreshCards(id); bump($("#saved-count"));
    toast(wish.has(id) ? "Saved" : "Removed from saved"); if (S.saved && SHELF) render(true); return;
  }
  if (t.dataset.chip) {
    const k = t.dataset.chip, v = t.dataset.v;
    if (k === "all") { const sort = S.sort; S = blank(); S.sort = sort; $$("#q,#q2").forEach(i => { i.value = ""; }); }
    else if (k === "q") { S.q = ""; $$("#q,#q2").forEach(i => { i.value = ""; }); }
    else if (k === "saved") S.saved = false;
    else S[k].delete(v);
    render(); writeURL(); return;
  }
  const line = id => byId.get(id) || bag.lines().find(l => l.id === id)?.p;
  if (t.dataset.rm != null) { const p = line(t.dataset.rm); if (p) { await bag.remove(p); saveCounts(); renderBag(); refreshCards(p.id); if (PP.p?.id === p.id) updPP(); } return; }
  if (t.dataset.inc != null) {
    const p = line(t.dataset.inc); if (!p) return;
    if (bag.get(p.id) >= p.q) { lowStock(p); return; }
    try { await bag.set(p, bag.get(p.id) + 1); } catch (err) { popup(err.message, true); }
    saveCounts(); renderBag(); if (PP.p?.id === p.id) updPP(); return;
  }
  if (t.dataset.dec != null) { const p = line(t.dataset.dec); if (!p) return; await bag.set(p, Math.max(1, bag.get(p.id) - 1)); saveCounts(); renderBag(); if (PP.p?.id === p.id) updPP(); return; }
  if (t.dataset.openBag != null) { e.preventDefault(); openBag(); return; }
  if (t.dataset.view) {
    if (PP.view === t.dataset.view) return; PP.view = t.dataset.view;
    $$("[data-view]").forEach(b => b.setAttribute("aria-selected", b === t));
    const st = $("#pp-stage"); $(".pp-shot", st)?.remove(); st.insertAdjacentHTML("beforeend", stageHTML(PP.p, PP.view)); return;
  }
  if (t.dataset.pdec != null) { PP.n--; updPP(); return; }
  if (t.dataset.pinc != null) { const p = PP.p; if (PP.n >= p.q - bag.get(p.id)) lowStock(p); else { PP.n++; updPP(); } return; }
  if (t.dataset.padd != null) {
    e.preventDefault(); const p = PP.p; if (!p) return;
    if (!byId.has(p.id)) byId.set(p.id, p);
    if (bag.get(p.id) >= p.q) { if (p.q) lowStock(p); return; }
    await addToBag(p.id, PP.n, t); PP.n = 1; updPP(); return;
  }
  if (t.dataset.copyLink != null) { copy(location.href, "Link copied"); return; }
  if (t.dataset.copyList != null) { copy(enquiryText(bag.lines()), "List copied"); return; }
  if (t.id === "more-btn") { S.shown += 24; render(true); }
});
document.addEventListener("change", e => {
  const t = e.target;
  if (t.dataset.f && SHELF) { t.checked ? S[t.dataset.f].add(t.value) : S[t.dataset.f].delete(t.value); render(); writeURL(); }
  if (t.id === "sort" && SHELF) { S.sort = t.value; render(); writeURL(); }
});
/* header search: filters the shelf live when the page has one, otherwise submits to the full shelf */
let qt, jumped = false;
function onSearch(v) {
  clearTimeout(qt);
  qt = setTimeout(() => {
    const sort = S.sort; if (S.b.size || S.g.size || S.k.size || S.c.size || S.sz.size || S.saved) { S = blank(); S.sort = sort; }
    S.q = v.trim(); render(); writeURL();
    const r = $("#shop").getBoundingClientRect();
    if (S.q && !jumped && (r.top > innerHeight * .6 || r.bottom < 0)) { jumped = true; $("#shop").scrollIntoView({ behavior: smooth() }); }
    if (!S.q) jumped = false;
  }, 180);
}
$$("#q,#q2").forEach(el => {
  el.addEventListener("input", () => { $$("#q,#q2").forEach(o => { if (o !== el) o.value = el.value; }); if ($("#shop")) onSearch(el.value); });
  el.form?.addEventListener("submit", ev => { if (!$("#shop")) return; ev.preventDefault(); onSearch(el.value); setTimeout(() => $("#shop").scrollIntoView({ behavior: smooth() }), 200); });
});
$("#bag-btn")?.addEventListener("click", e => { e.preventDefault(); openBag(); });
$("#bag-close")?.addEventListener("click", () => closeBag());
$("#saved-btn")?.addEventListener("click", e => {
  if (!$("#shop") || !SHELF) return; e.preventDefault();
  const sort = S.sort; S = blank(); S.sort = sort; S.saved = true; render(); writeURL(); shelfJump();
});
$("#scrim")?.addEventListener("click", () => { closeBag(); closeFilters(); });
$("#toast-btn")?.addEventListener("click", () => { $("#toast").classList.remove("on"); openBag(); });
$("#m-search-btn")?.addEventListener("click", e => { const on = $("#m-search").classList.toggle("on"); e.currentTarget.setAttribute("aria-expanded", on); if (on) $("#q2").focus(); });
$("#pop-ok")?.addEventListener("click", closePop);
$("#pop-bag")?.addEventListener("click", () => { closePop(); openBag(); });
$("#pop")?.addEventListener("click", e => { if (e.target === $("#pop")) closePop(); });
document.addEventListener("keydown", e => {
  if ($("#pop") && !$("#pop").hidden) {
    if (e.key === "Escape") { e.stopImmediatePropagation(); closePop(); return; }
    if (e.key === "Tab") { const f = $$("#pop button:not([hidden])"); const i = f.indexOf(document.activeElement); e.preventDefault(); f[(i + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus(); }
    return;
  }
  if (e.key === "Escape") { if ($("#drawer")?.classList.contains("on")) closeBag(); closeFilters(); if ($("#mega")?.classList.contains("on")) { setMega(false); $("#brands-trigger").focus(); } }
});
/* enquiry form in the drawer: the list goes into the message body, Shopify emails it to the store */
$$("[data-enquiry-form]").forEach(f => f.addEventListener("submit", e => {
  const lines = bag.lines(); if (!lines.length) { e.preventDefault(); return; }
  const note = $("[data-enquiry-note]", f)?.value.trim();
  $("[data-enquiry-body]", f).value = enquiryText(lines) + (note ? `\n\nNote: ${note}` : "");
  store.set("sent", Date.now());
}));
/* FAQ deep links (#faq-…) open their answer */
function openDetails() {
  const el = location.hash.length > 1 && document.getElementById(decodeURIComponent(location.hash.slice(1)));
  if (el && el.tagName === "DETAILS") { el.open = true; requestAnimationFrame(() => el.scrollIntoView({ behavior: "auto", block: "center" })); }
}
addEventListener("hashchange", openDetails);

/* ---------- brands dropdown ---------- */
const mega = $("#mega"), megaBtn = $("#brands-trigger");
const canHover = matchMedia("(hover: hover) and (pointer: fine)");
let megaT;
function setMega(on) {
  if (!mega) return;
  clearTimeout(megaT);
  if (on && window.closePk) window.closePk();
  mega.classList.toggle("on", on); megaBtn.setAttribute("aria-expanded", on);
  if (!on && $("#mega-q").value) { $("#mega-q").value = ""; filterMega(); }
}
function filterMega() {
  const q = norm($("#mega-q").value.trim());
  let any = false;
  $$(".mega-group", mega).forEach(g => {
    let vis = 0;
    $$("a", g).forEach(a => { const on = !q || norm(a.textContent).includes(q); a.hidden = !on; if (on) vis++; });
    g.hidden = !vis; if (vis) any = true;
  });
  $("#mega-empty").hidden = any;
  $("#mega-empty").textContent = any ? "" : `No brand matches “${$("#mega-q").value.trim()}”.`;
}
if (mega && megaBtn) {
  const megaLi = megaBtn.parentElement;
  [megaLi, mega].forEach(el => {
    el.addEventListener("mouseenter", () => { if (!canHover.matches) return; clearTimeout(megaT); megaT = setTimeout(() => setMega(true), 90); });
    el.addEventListener("mouseleave", () => { if (!canHover.matches || document.activeElement === $("#mega-q")) return; clearTimeout(megaT); megaT = setTimeout(() => setMega(false), 180); });
  });
  megaBtn.addEventListener("click", e => { if (canHover.matches) { setMega(false); return; } e.preventDefault(); setMega(!mega.classList.contains("on")); });
  megaBtn.addEventListener("keydown", e => { if (e.key === "ArrowDown") { e.preventDefault(); setMega(true); setTimeout(() => $("#mega-q").focus(), 60); } });
  mega.addEventListener("click", e => { if (e.target.closest("a")) setMega(false); });
  mega.addEventListener("focusout", e => { if (!e.relatedTarget || !e.relatedTarget.closest("nav.main")) setMega(false); });
  document.addEventListener("click", e => { if (mega.classList.contains("on") && !e.target.closest("nav.main")) setMega(false); });
  $("#mega-q").addEventListener("input", filterMega);
}

/* ---------- packaging dropdowns: Men / Women / Infants ---------- */
(() => {
  const nav = $("nav.main"); if (!nav) return;
  const hoverOK = matchMedia("(hover: hover) and (pointer: fine)");
  let cur = null, t = 0;
  const panel = a => document.getElementById(a.getAttribute("aria-controls"));
  const open = (a, focus) => {
    clearTimeout(t); setMega(false);
    if (cur && cur !== a) close();
    const pk = panel(a); if (!pk) return;
    cur = a; a.setAttribute("aria-expanded", "true");
    const nr = nav.getBoundingClientRect(), ar = a.getBoundingClientRect();
    pk.classList.add("on");
    pk.style.left = Math.max(10, Math.min(ar.left - nr.left - 12, nr.width - pk.offsetWidth - 10)) + "px";
    if (focus) setTimeout(() => pk.querySelector("a:not([hidden])")?.focus(), 30);
  };
  const close = () => { clearTimeout(t); if (cur) { panel(cur)?.classList.remove("on"); cur.setAttribute("aria-expanded", "false"); } cur = null; };
  window.closePk = close;
  $$("[data-pk]").forEach(a => {
    const pk = panel(a); if (!pk) return;
    a.addEventListener("mouseenter", () => { if (hoverOK.matches) open(a); });
    a.addEventListener("mouseleave", () => { if (hoverOK.matches) t = setTimeout(close, 180); });
    a.addEventListener("click", e => { if (hoverOK.matches) { close(); return; } if (cur !== a) { e.preventDefault(); open(a); } else close(); });
    a.addEventListener("keydown", e => { if (e.key === "ArrowDown") { e.preventDefault(); open(a, true); } });
    pk.addEventListener("mouseenter", () => clearTimeout(t));
    pk.addEventListener("mouseleave", () => { if (hoverOK.matches) t = setTimeout(close, 180); });
    pk.addEventListener("focusout", e => { if (!e.relatedTarget || !e.relatedTarget.closest(".pk,[data-pk]")) close(); });
  });
  document.addEventListener("click", e => { if (cur && !e.target.closest(".pk,[data-pk]")) close(); });
  document.addEventListener("keydown", e => { if (e.key === "Escape" && cur) { const a = cur; close(); a.focus(); } });
  nav.querySelector("ul")?.addEventListener("scroll", close, { passive: true });
})();

/* ---------- boot ---------- */
(async () => {
  hydrateBottles();
  const h1 = $(".hero h1.split"); if (h1 && !reduced) splitWords(h1);
  initMarquee(); initTop();
  const prod = $("[data-product]"); if (prod) initProduct(prod);
  $$("main section.block .sec-head, .about > div, .news").forEach(el => el.classList.add("reveal"));
  observe(); openDetails();
  try { setData(await fetchShelf(VD.dataUrl)); }
  catch (err) { console.warn("Vintage Duft: catalogue data unavailable", err); }
  await bag.sync();
  /* coming back from a sent enquiry form */
  const sent = store.get("sent", 0);
  if (/contact_posted=true/.test(location.search) && sent && Date.now() - sent < 600000) { await bag.clear(); store.set("sent", 0); toast("Thank you. Your enquiry is on its way, and we’ll reply soon."); }
  saveCounts();
  renderStats(); renderRare(); renderMega(); enrichProduct();
  const shop = $("#shop");
  if (shop) {
    let list = P;
    const src = shop.dataset.source;
    if (src && src !== VD.dataUrl) { try { list = (await fetchShelf(src)).map(prep).filter(visible); list.forEach(p => { if (!byId.has(p.id)) byId.set(p.id, p); }); } catch { list = P; } }
    if (list.length) initShelf(list); else shop.querySelector("#grid")?.removeAttribute("data-fallback");
  }
  if ($("#cart-lines")) renderBag();
  observe();
})();

/* ---------- theme editor: a section re-rendered after a setting change gets its behaviour back ---------- */
document.addEventListener("shopify:section:load", e => {
  const el = e.target;
  hydrateBottles(el);
  const h1 = $(".hero h1.split", el); if (h1 && !reduced) splitWords(h1);
  if ($("#mq", el)) initMarquee();
  if ($("#top-list", el)) initTop();
  if ($("#rail", el)) renderRare();
  if ($("#shop", el) && P.length) initShelf(P);
  if ($("[data-pk-row]", el)) renderMega();
  renderStats();
  $$("section.block .sec-head, .about > div, .news", el).forEach(x => x.classList.add("reveal"));
  $$(".reveal", el).forEach(x => x.classList.add("in"));
});
})();
